import { createJobFetchers } from "@artha/utils";

const APP_ORIGIN =
  process.env.NEXT_PUBLIC_APP_URL ||
  process.env.NEXT_PUBLIC_SITE_URL ||
  (process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : undefined) ||
  "http://localhost:3000";

const getJobApiBase = (baseUrl?: string) => {
  if (baseUrl) return baseUrl;
  if (typeof window === "undefined") {
    const directBackend = process.env.JOBS_API_BASE_URL || process.env.NEXT_PUBLIC_JOBS_API_BASE_URL;
    if (directBackend) {
      return directBackend.replace(/\/+$/, "");
    }
    return new URL("/api/job-api", APP_ORIGIN).toString();
  }
  return "/api/job-api";
};

const jobFetchers = createJobFetchers({ getBaseUrl: getJobApiBase });

export const {
  fetchJobs,
  fetchPublicJobs,
  fetchPublicJobCount,
  fetchPublicJobFilters,
  fetchSimilarJobs,
  fetchRecommendSearch,
  fetchJobSuggestions,
  fetchJobBySlug,
  fetchFilters,
  fetchCompanyFilters,
  fetchJobCount,
  buildQueryString,
} = jobFetchers;
